module.exports = __webpack_public_path__ + "img/estacionamento_inteligente.d926fc8b.png";